angular
.module( 'ribytRsvpApp' )
    .directive('activityByt', function ($sessionStorage, $rootScope, $state, $http, ENV, $timeout, $sce) {
    return {
        'restrict': 'E',
        'scope': {
            'currentByt': '@',
            'eventDigitalLink': '@',
            'eventLocation': '@',
            'inviteType': '@',
            'isTimeFormat24': '@'
        },
        'templateUrl': 'views/directives/itinerary/activityByt.html',
        'link': function ( scope, element, attrs ) {
            // we give full trust that the code in our database is safe. Otherwise, we get some other issues with styling not being displayed properly
            scope.trustedHtml = function (plainText) {
                return $sce.trustAsHtml(plainText);
            }

            var byt = JSON.parse( scope.currentByt );
            var newByt = {};
            scope.pdfView = _.get( $sessionStorage, 'pdfView', false );
            scope.eventLocation = JSON.parse( scope.eventLocation );

            scope.isAccepted = function ( passedByt ) {
                var data = {
                    bytID: passedByt.bytID.id,
                    status: passedByt.isAccepted
                };
                $http.put( ENV.apiEndpoint + '/ribyt/rsvp/setBytStatus/' + $sessionStorage.inviteHash, data )
                        .then( function setBytStatus ( ) {
                            // update the invite session storage/scope just in case they refresh
                            var invitation = $rootScope.decryptInvite( _.get( $sessionStorage, 'invitation' ) );

                            // find the byt in the invite
                            var modifiedBytIndex = _.findIndex( _.get( invitation, 'byts' ), {'bytID.id': _.get( passedByt, 'bytID.id' )} );

                            // set the isAccepted value to the invite
                            _.set( invitation, 'byts[' + modifiedBytIndex + '].isAccepted', passedByt.isAccepted );
                            // save the results in $sessionStorage
                            _.set( $sessionStorage, 'invitation', $rootScope.encryptInvite( invitation ) );
                        }, function setBytStatusError ( error ) {
                        } );
            };

                // _.each(byt, function(b, key){
                //     newByt[key]=b;
                // });
                // scope.byt = newByt;
            scope.byt = byt;
            scope.preview = $rootScope.preview;

            var invite = $rootScope.decryptInvite(_.get($sessionStorage, 'invitation'));
            var experience = _.get(invite, 'experienceID');

            // Find out if we should hide the count of barcodes.. RPT-2896 for now this is checking the Hide byt quantity
            var hideCount = _.get(experience, 'RSVPDetails.hideCount');
            if ( hideCount ) {
                scope.byt.hideCount = true;
            }

            // get the correct name to display
            var otherDetail = false;
            // first check if this is type 'Other' and that there is a value for otherDetail
            if ( _.get( byt, 'bytID.accessControl.otherDetail' ) && _.get( byt, 'bytID.accessControl.bytAccess' ) === 'Other' ) {
                // if there is, this is the value we will use
                otherDetail = _.get( byt, 'bytID.accessControl.otherDetail' );
            }

            // if there is no otherDetail, we will ust the bytAccess name
            scope.accessControlName = otherDetail || _.get( byt, 'bytID.accessControl.bytAccess' );

            // pluralize the activity accessControl
            var quantityOfByt = 0;



            // we need to figure out the quantity of this byt
            if ( scope.inviteType === 'i' ) {
                // if they are a guest, use this value
                quantityOfByt = byt.qty;
            } else if ( scope.inviteType === 'g' ) {
                // if they are a companion, use this value
                quantityOfByt = byt.qtyCompanion;
            }
            // if there is only one of this byt, make it singular if it is one of our values. it should be set as singular at the byt level if it is a custom access control, like 'toy'
            if ( quantityOfByt === 1 && _.includes( ['Credentials', 'Tickets', 'VIP Credentials', 'Guest Reservations'], scope.accessControlName ) ) {
                // if this is one of our items, we need to make it singular
                scope.accessControlName = _.trimEnd( scope.accessControlName, 's' );
            } else if ( quantityOfByt > 1 ) {
                // if there is more than one, we need to pluralize it
                var lastTwoLetters = scope.accessControlName.substr( scope.accessControlName.length - 2 );
                switch ( lastTwoLetters ) {
                case 'ch':
                case 'sh':
                case 'ss':
                    // add es
                    scope.accessControlName += 'es';
                    break;
                case 'fe':
                    // change this to ves
                    scope.accessControlName = _.trimEnd( scope.accessControlName, 'fe' );
                    scope.accessControlName += 'ves';
                    break;

                // check single letter rules
                default:

                    var lastLetter = scope.accessControlName.substr( scope.accessControlName.length - 1 );
                    switch ( lastLetter ) {
                    case 'x':
                        // add es
                        scope.accessControlName += 'es';
                        break;
                    case 'f':
                        // change this to ves
                        scope.accessControlName = _.trimEnd( scope.accessControlName, 'f' );
                        scope.accessControlName += 'ves';
                        break;
                    case 's':
                        // do nothing for ends with s
                        break;
                    case 'y':

                        // we need to check if the 2nd to last is a consonant or vowel

                        var secondToLastLetter = scope.accessControlName.substr( scope.accessControlName.length - 2, scope.accessControlName.length - 2);
                        switch ( secondToLastLetter ) {
                        case 'a':
                        case 'e':
                        case 'i':
                        case 'o':
                        case 'u':
                            // add s
                            scope.accessControlName += 's';
                            break;
                        default:
                            // change this to ies
                            scope.accessControlName = _.trimEnd( scope.accessControlName, 'y' );
                            scope.accessControlName += 'ies';
                            break;
                        }

                        break;

                    case 'o':

                        // we need to check if the 2nd to last is a consonant or vowel
                        var secondToLastLetter = scope.accessControlName.substr( scope.accessControlName.length - 2, scope.accessControlName.length - 1 );
                        switch ( secondToLastLetter ) {
                        case 'a':
                        case 'e':
                        case 'i':
                        case 'o':
                        case 'u':
                            // add s
                            scope.accessControlName += 's';
                            break;
                        default:
                            // add es
                            scope.accessControlName += 'es';
                            break;
                        }

                        break;

                    default:
                        scope.accessControlName += 's';
                        break;
                    }
                    break;
                }
            }
            var addressInfo = ['address', 'locality', 'region', 'postcode'];
            scope.location = [];

            var hasAddress = false;
                // setup the location information in an array so we can read it easier on the FE
            _.forEach( addressInfo, function eachAddress ( address ) {
                var addComma = ',';
                if ( address === 'postcode' || address === 'region' ) {
                    addComma = '';
                }

                var bytAddressType = _.trim( _.get( scope, 'byt.bytID.locationData.' + address, '' ) );

                if ( bytAddressType && bytAddressType !== '' ) {
                    scope.location.push( bytAddressType + addComma );
                    hasAddress = true;
                }
            } );
            var barcodes = _.get( byt, 'bytDetails.barcode', null );
            scope.hasMultipleBarcodes = barcodes && Array.isArray( barcodes );

                // we need to wait until the angular variable barcodeReady is set, because otherwise, the jquery script we use for generating barcodes won't find it
            $timeout( function () {
                    // http://www.jqueryscript.net/other/Simple-jQuery-Based-Barcode-Generator-Barcode.html
                if ( barcodes && _.get( byt, 'bytID.accessControl.barcodeType' ) ) {
                    var type = '';
                    switch ( _.get( byt, 'bytID.accessControl.barcodeType' ) ) {
                    case 'Interleaved 2 of 5':
                        type = 'int25';
                        break;
                    case 'Code 128':
                        type = 'code128';
                        break;
                    default:
                        type = 'int25';
                    }

                    var settings = {
                        'barWidth': '2',
                        'barHeight': '69',
                        'fontSize': '18'
                    };

                    if ( scope.hasMultipleBarcodes ) {
                        barcodes.forEach( function ( barcode, index ) {
                            $( '#barcode' + byt.bytID.id + index ).barcode( barcode, type, settings );
                        } );
                    } else {
                        $( '#barcode' + byt.bytID.id ).barcode( barcodes, type, settings );
                    }
                }
            } );

                // display TBD if the hotel location has not been setup yet
                    // removed TBD per rpt-2360
            if ( byt.bytID.useEventLocation ) {
                if ( scope.eventLocation && scope.eventLocation.formatted_location ) {
                    scope.location = [scope.eventLocation.formatted_location, scope.eventLocation.venue].filter( Boolean ).join( ', ' );
                } else {
                    scope.location = '';
                    scope.digitalLink = scope.eventDigitalLink;
                }
            } else if ( hasAddress ) {
                scope.location = scope.location.join( ' ' );
            } else {
                scope.location = '';
            }
        }
    };
} )
